import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export const ObjectionSection: React.FC = () => {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-108">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-beige-100 rounded-full opacity-30 blur-3xl -z-10" data-id="element-109"></div>

      <div className="container mx-auto px-6 max-w-3xl text-center" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-dark p-10 md:p-14 rounded-3xl shadow-xl border border-gray-800 relative" data-id="element-111">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-coral-500 text-white p-3 rounded-full shadow-lg z-10" data-id="element-112">
            <Sparkles className="w-6 h-6" data-id="element-113" />
          </div>

          <div className="w-full h-48 md:h-56 rounded-2xl overflow-hidden mb-8 mt-4" data-id="element-114">
            <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&h=400&fit=crop&q=80" alt="Creadora de contenido trabajando desde casa" className="w-full h-full object-cover" style={{
            filter: 'sepia(15%) saturate(85%) brightness(105%)'
          }} data-id="element-115" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-116">
            {t('objection.title')}
          </h2>

          <p className="text-xl text-gray-300 font-sans leading-relaxed mb-0" data-id="element-117">
            <span className="font-semibold text-coral-400" data-id="element-118">
              {t('objection.highlight')}
            </span>{' '}
            {t('objection.desc.1')}{' '}
            <span className="italic" data-id="element-119">{t('objection.desc.2')}</span>
            {t('objection.desc.3')}
          </p>
        </motion.div>
      </div>
    </section>;
};